export class Cart {
    products

    

    constructor() {
        this.products = [];
    }


    get() {
        return {
            products: this.products,
        }
    }

    /**
     * 
     * @param {Product} product 
     */
    addProduct(product) {
        this.products.push(product)
    }

    /**
     * 
     * @param {Array} products 
     */
    updateCompleteCartWithNewProducts(products) {
        this.products = products;
    }




    saveCartToLocalStorage(cart) {
        localStorage.setItem('cart', JSON.stringify(this.get()));
        updateCartInHeader(this.get());
    }
    

    getCartFromLocalStorage() {
        let cartJSON = localStorage.getItem('cart');
        let cartObj = JSON.parse(cartJSON);
    
        return cartObj;
    
    }

    searchProductByParameters(product365, addons, places) {
        for(let product of this.products) {
            if(product.product365.name === product365 && JSON.stringify(product.addOns) === JSON.stringify(addons) && product.places === places) {
                return product;
            }
        }
    }

    deleteProductByParameters(product365, addons, places) {
        for(let i in this.products) {
            let product = this.products[i]
            if(product.product365.name === product365 && JSON.stringify(product.addOns) === JSON.stringify(addons) && product.places === places) {
                console.log(this.products.length)
                this.products.splice(i, 1);
                console.log("deleted product ", product)
                console.log(this.products.length)
            }
        }
    }

}



export function updateCartInHeader(cart) {
    const cartAmountElement = document.getElementById("anzahl-bundles");
    if(cartAmountElement && cart.products) {
        cartAmountElement.innerText = cart.products.length;
    }
}